export enum chatTypes {
  ADD_CHAT_NOTIFICATION = 'ADD_CHAT_NOTIFICATION',
  SET_CHAT_NOTIFICATIONS = 'SET_CHAT_NOTIFICATIONS',
  RESET_CHAT_NOTIFICATIONS = 'RESET_CHAT_NOTIFICATIONS',
}
